<div class="menu-container" #menuContainer>
	<div class="abrirMenu">
		<p>
			<fa-icon [icon]="faBars" #abrirButton (click)="abrirMenu()"></fa-icon>
		</p>
	</div>
	<div class="menuExtra" id="menu" #menuOffCanvas>
		<div class="cerrarMenu">
			<p>
				<fa-icon [icon]="faTimesCircle" #cerrarButton (click)="abrirMenu()"></fa-icon>
			</p>
		</div>
		<div class="extra" #extra>
			<div class="covid">
				<fa-icon [icon]="faVirus"></fa-icon>
				<h1>COVID-19</h1>
			</div>
			<div class="contacto-header">
				<h1>Central de Atendimento: <a href=""> (11) 3333-4444</a></h1>
				<h1><a [routerLink]="['../login']">
					<fa-icon [icon]="faUserAlt"></fa-icon> Clinica Life</a></h1>
			</div>
		</div>
		<div class="menu" #menu>
			<nav>
				<ul>
					<li><a href="" [routerLink]="['../home']"><fa-icon [icon]="faHome"></fa-icon></a></li>
					<li><a href="">Especialidades</a></li>
					<li><a href="" [routerLink]="['../doctores']">Equipe Médica</a></li>
					<li><a href="">Contato</a></li>
					<li><a href="" class="cita" [routerLink]="['../login']">Agendar Consulta</a></li>
				</ul>
			</nav>
		</div>
	</div>
	<div class="logo-container" #logoContainer>
		<figure class="logo">
			<img src="./../../assets/img/logo.png" alt="logo" #logo>
		</figure>
	</div>
</div>


<div class="doctores-container">
	<div class="titulo">
		<h1>Nossos médicos</h1>
	</div>
	<div class="doctores">
		<div class="doctor" *ngFor = "let valor of doctores; let indice = index">
			<h1>{{valor.nombre}}</h1>
			<p><strong>Universidade:</strong> {{valor.universidad}}</p>
			<p><strong>Especialista:</strong> {{valor.especialidad}}</p>
			<p><strong>Anos de serviço:</strong> {{valor.anosServicio}}</p> 
			<p><strong>Pontuação:</strong> {{valor.puntuacion}}</p>
			<p><strong>Número da matrícula (cmp):</strong> {{valor.cmp}}</p>
			<img src="../../assets/img/doctores/{{valor.imgUrl}}">
		</div>
	</div>
</div>



















<footer class="footer-container">
	<div class="footer-main" #footerMain>
		<div class="footer-left">
			<img src="./../../assets/img/logo.png" alt="Logo">
			<p>© 2022 Clínica Life</p>
		</div>
		<div class="footer-info" #footerInfo>
			<h2 class="footer-title">Mais informação</h2>
			<ul>
				<li>
					<a href="#">Sobre nós</a>
				</li>
				<li>
					<a href="#">Nossas especialidades</a>
				</li>
				<li>
					<a href="#">Nossa equipe médica</a>
				</li>
			</ul>
		</div>
		<div class="footer-contact" #footerContact>
			<h2 class="footer-title">Contate-Nos</h2>
			<form action="">
				<input class="input" type="email" name="email" id="email" placeholder="Correio eletrônico">
				<input class="button" type="submit" value="Enviar">
			</form>
		</div>
	</div>
</footer>